import React, { memo } from "react";
import { Grid } from "@material-ui/core";
import "./styles.css";

const Header = () => (
  <Grid container className="loan-proceeds-settings-run-table-header-wrapper" xs={12}>
    <Grid item xs={12}><h1 className="loan-proceeds-settings-run-table-header-title-text">Loan Proceeds Run Table</h1></Grid>
    <Grid container item xs={12} justify="center">
      <div className="loan-proceeds-settings-run-table-header-instructions-text-wrapper">
        <div className="loan-proceeds-settings-run-table-header-instructions-text">Select which loan and property types you'd like to run proceeds calculations on below.</div>
        <div className="loan-proceeds-settings-run-table-header-instructions-text">Save your selections by clicking the "Update" button.</div>
      </div>
    </Grid>
  </Grid>
);

export default memo(Header);
